import optimizeText from './optimize_text/zh'
export default {
  ...optimizeText
}
